import { api } from './api'

export const fetchAction = (query) => api.get('/action', query)
